import React from 'react'
import { Link } from 'react-router-dom'
import OtpInput from 'react-otp-input';
import appRoutes from '../../routes/routeConfig'

const OTPVerification = () => {
    return (
        <div className="account-body accountbg">
            <div className="container">
                <div className="row vh-100 d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-5 mx-auto">
                                <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            <Link to='/' className="logo logo-admin">
                                                <img src="/assets/images/logo-sm.png" height="50" alt="logo" className="auth-logo" />
                                            </Link>
                                            <h4 className="mt-3 mb-1 font-weight-semibold text-white font-18">Reset Password</h4>   
                                            <p className="text-white mb-0">Please enter your RSA code below to reset your password!</p>  
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <form className="form-horizontal auth-form my-4" action="index.html">
                    
                                            <div className="form-group">
                                                <label htmlFor="username">RSA Code</label>
                                                <div className="input-group mb-3 otp-container">          
                                                    <OtpInput
                                                        className='otp-input'
                                                        // value={this.state.otp}
                                                        // onChange={this.handleChange}
                                                        numInputs={8}
                                                    />                                                                               
                                                </div>                                    
                                            </div>
                                            <div className="form-group mb-0 row">
                                                <div className="col-12 mt-2">
                                                    <Link to={appRoutes.forgotPassword.reset}>
                                                        <button className="btn btn-primary btn-block waves-effect waves-light" type="button">Reset <i className="fas fa-sign-in-alt ml-1"></i></button>
                                                    </Link>
                                                </div>
                                            </div>                    
                                        </form>
                                        <p className="text-muted mb-0">Remember It ?  <Link to="/login" className="text-primary ml-2">Sign in here</Link></p>
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Central Bank of Nigeria &copy; 2022</span>                                           
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OTPVerification